/* How a sheet finds out how tall its content wants to be.
 *
 * ═══ WHY THIS IS A CONTRACT AND NOT A querySelector ═══
 *
 * The rule it serves is "a detent is a CEILING, not a target": the sheet rises
 * to the smaller of the detent and what it is actually holding. Measured on the
 * route panel before that rule existed, the content was 314 px and the detent
 * was 0.88 x 660 = 582, so opening the sheet put 268 px of empty panel over the
 * chart — the original complaint, arrived at from the other direction.
 *
 * The old `MobileSheet` could measure directly because it owned the scroll box.
 * `<Panel>` owns it now, so the sheet has to ask. It could reach in with
 * `querySelector('.body')` — Svelte's scoped classes are additive, so that
 * would even work — and that is exactly the cross-component reach this whole
 * refactor exists to delete. Fourteen such constants were removed from the
 * phone layout; adding one back through the DOM would be the same mistake with
 * better manners.
 *
 * So: a symbol, a function, and a component that reports its own height.
 * Nothing outside a sheet provides it, and `<Panel>` simply does not measure
 * when nobody is listening.
 */

/** Context key. A symbol so it cannot collide with a host's own context. */
export const SHEET_MEASURE = Symbol('gennetay.sheet.measure');

/** What a panel inside a sheet reports: the height it would need to show
 *  everything, chrome included. */
export type ReportHeight = (px: number) => void;
